//shared camera zoom/pan uniforms: every rope-hung figure's meshes reference these same values, so
//zooming out and panning to follow the swinger's speed affects the whole scene, not just its own figure.
export const zoom_min = 0.33; //furthest the camera zooms out at high speed
export const zoom_max = 1.5; //zoom at rest

export const zoom = { value: zoom_max };
export const pan = { x: 0, y: -1 };

const pan_aim_x = 2.5; //world units the camera drifts right at full zoom-out
const pan_aim_y = -1; //world units the camera drifts up at full zoom-out (twrk y-down, so negative is up)

//extra pan target added by events (the catch): camera_shift(dx) makes the camera drift dx further
//right, eased by the same follow rate as the speed-based pan
const shift = { x: 0 };
export function camera_shift(dx: number) { shift.x += dx; }

//jump (space) pull-back: while jumping the zoom aim is forced all the way out to zoom_min
//regardless of speed, snapping there fast; landing (catch or fail) snaps back just as fast so the
//normal speed-based zoom, which eases slowly, is never on the hook for either transition
let jumping = false;
let landed_at = 0; //timestamp (ms) of the last camera_land(), so update can stay fast briefly after
export function camera_jump() { jumping = true; }
export function camera_land() { jumping = false; landed_at = performance.now(); }

//eases zoom.value/pan towards targets derived from speed: fast swings zoom out (floor zoom_min) and pan
//up/right, at rest zoom settles at zoom_max and pan returns to center (plus any event shift). Jumping
//overrides the zoom aim to zoom_min, and both entering and leaving that state ease in fast so the
//pull-back and its recovery read as sharp camera beats, distinct from the slow speed-based drift.
const land_settle_ms = 400; //how long after landing the fast ease stays active, to finish the snap back
export function camera_update(speed: number) {
    const speed_aim = Math.max(zoom_min, zoom_max / (1 + speed * 0.5));
    const aim = jumping ? zoom_min : speed_aim;
    const t = 1 - aim / zoom_max; //0 at rest, →1 as it zooms out
    const settling = performance.now() - landed_at < land_settle_ms;
    const zoom_rate = (jumping || settling) ? 0.015 : 0.0025;
    zoom.value -= (zoom.value - aim) * zoom_rate;
    pan.x -= (pan.x - (pan_aim_x * t + shift.x)) * 0.0025;
    pan.y -= (pan.y - pan_aim_y * t) * 0.0025;
}
